export const Endpoint = () => `/api/v3/license/starttrial/`;
export const Csrf = () => `/api/v3/useraction/token/`;
export declare const QueryKey: never;
export type Payload = undefined;
export type Response = void;
